import { Box, IconButton } from "@mui/material";
import closeIcon from "assets/closeIconWhite.svg";
import suitInforma from "assets/suitInforma.png";
import { ModalDialog } from "components";
import { FC } from "react";
import { FUMICO_PHONE_NUMBER } from "../../config/fumico";

interface ModalWhatsAppUpdateProps {
  open: boolean;
  setOpen(value: boolean): void;
}

const ModalWhatsAppUpdate: FC<ModalWhatsAppUpdateProps> = ({ open, setOpen }) => {
  const close = () => {
    setOpen(false);
    window.localStorage.setItem("modalWhatsAppUpdate4", "false");
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Oi");
    window.open(`https://wa.me/${FUMICO_PHONE_NUMBER}?text=${message}`, "_blank");
  };

  return (
    <ModalDialog open={open} setOpen={close}>
      <Box position="relative">
        <Box
          position="absolute"
          top={0}
          right={0}
          zIndex={1}
        >
          <IconButton onClick={close} aria-label="fechar">
            <img
              src={closeIcon}
              alt="fechar"
              style={{ mixBlendMode: "difference" }}
            />
          </IconButton>
        </Box>
        <img
          src={suitInforma}
          alt="Novo número de WhatsApp"
          onClick={handleWhatsAppClick}
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            cursor: "pointer",
          }}
        />
      </Box>
    </ModalDialog>
  );
};
export default ModalWhatsAppUpdate;
